// Raretto — luxury brand content
// All images sourced from raretto.com; missing flavours use elegant placeholder tiles.

export const BRAND = {
  name: 'Raretto',
  tagline: 'A rare chocolate house from Mumbai.',
  city: 'Mumbai',
};

// 13 signature flavours — the complete Raretto Crunch atelier
export const CRUNCH_FLAVORS = [
  {
    id: 'hazelnut',
    name: 'Hazelnut',
    couplet: 'Piedmont hazelnut, roasted whole.',
    tasting: 'Slow-roasted Piedmont hazelnut layered into silken milk chocolate. Deep, warm, unmistakably nutty.',
    image: 'https://raretto.com/images/hazelnut.jpeg',
    color: '#7a4a2a',
    origin: 'Italian hazelnut · Belgian couverture',
  },
  {
    id: 'cookies',
    name: 'Cookie',
    couplet: 'A quiet nostalgia.',
    tasting: 'Hand-crushed vanilla cookie folded through milk chocolate. Familiar, at first. Considered, on reflection.',
    image: 'https://raretto.com/images/cookie.jpeg',
    color: '#5c3a20',
    origin: 'House-baked cookie · Belgian couverture',
  },
  {
    id: 'mangoes',
    name: 'Mango',
    couplet: 'Alphonso, in chocolate.',
    tasting: 'Alphonso mango preserved at its ripest, married with white chocolate. Summer, held.',
    image: 'https://raretto.com/images/mango.jpeg',
    color: '#c9832b',
    origin: 'Ratnagiri Alphonso · French white chocolate',
  },
  {
    id: 'paan',
    name: 'Paan',
    couplet: 'The finish of an evening.',
    tasting: 'Betel leaf, rose gulkand, fennel. An Indian ritual, reimagined in chocolate.',
    image: 'https://raretto.com/images/paan.jpeg',
    color: '#3d5a3a',
    origin: 'Banarasi paan blend · White chocolate',
  },
  {
    id: 'blackcurrant',
    name: 'Black Currant',
    couplet: 'Tart. Deep. Unexpected.',
    tasting: 'Wild black currant, dark chocolate, a whisper of tannin. Composed for those who prefer their sweet with edge.',
    image: 'https://raretto.com/images/blackcurrant.jpeg',
    color: '#4a1e3a',
    origin: 'European black currant · 62% dark',
  },
  {
    id: 'gulkand',
    name: 'Gulkand',
    couplet: 'Rose petal, preserved.',
    tasting: 'Handmade gulkand - rose petals slowly cured in the sun, folded through white chocolate. Ceremonial.',
    image: 'https://raretto.com/images/gulkand.jpeg',
    color: '#8c3a5a',
    origin: 'Sun-cured rose gulkand · White chocolate',
  },
  {
    id: 'coconut',
    name: 'Coconut',
    couplet: 'Toasted, then tempered.',
    tasting: 'Slow-toasted coconut flakes suspended in milk chocolate. Coastal, calm, quietly indulgent.',
    image: 'https://raretto.com/images/coconut.jpeg',
    color: '#a58c6a',
    origin: 'Kerala coconut · Belgian couverture',
  },
  {
    id: 'biscoff',
    name: 'Biscoff',
    couplet: 'Caramelised, at every layer.',
    tasting: 'Belgian caramelised biscuit crushed into milk chocolate. Buttery. Considered.',
    image: 'https://raretto.com/images/biscoff.jpeg',
    color: '#a06638',
    origin: 'Lotus Biscoff · Milk chocolate',
  },
  {
    id: 'coffee',
    name: 'Coffee',
    couplet: 'Espresso, in a darker form.',
    tasting: 'Chikmagalur single-origin espresso woven through dark chocolate. For late hours and long conversations.',
    image: 'https://raretto.com/images/coffee.jpeg',
    color: '#3a2418',
    origin: 'Chikmagalur espresso · 62% dark',
  },
  {
    id: 'orange',
    name: 'Orange',
    couplet: 'Zest, held in dark chocolate.',
    tasting: 'Sicilian orange peel candied in-house, tempered into dark chocolate. Bright, bitter, brilliant.',
    image: 'https://raretto.com/images/orange.jpeg',
    color: '#c86428',
    origin: 'Sicilian orange · 62% dark',
  },
  {
    id: 'darkfantasy',
    name: 'Dark Fantasy',
    couplet: 'For those who prefer the shadow.',
    tasting: 'A deeper cocoa, a rounder finish. Composed for the palate that has stopped chasing sweetness.',
    // no HD image yet — render as elegant gradient card
    image: 'https://raretto.com/images/darkFantasy.jpeg',
    color: '#1a0d08',
    origin: 'Single-origin cocoa · 70% dark',
  },
  {
    id: 'nutella',
    name: 'Nutella',
    couplet: 'Hazelnut, layered again.',
    tasting: 'Silken hazelnut praline folded through Nutella and milk chocolate. Doubled. Deepened.',
    image: 'https://raretto.com/images/nutella.jpeg',
    color: '#4a2a12',
    origin: 'Hazelnut praline · Milk chocolate',
  },
  {
    id: 'caramel',
    name: 'Caramel',
    couplet: 'Slow-burned. Never rushed.',
    tasting: 'Sugar taken to the edge of dark, cooled with cream, tempered into chocolate. Patient.',
    image: 'https://raretto.com/images/caramel.jpeg',
    color: '#8a5220',
    origin: 'House-cured caramel · Milk chocolate',
  },
];

export const BOX_500G_PRICE = { mrp: 1280, sale: 1080 };
export const BYO_PIECE_PRICE = 40;

// Nutrition (per 100g) — sourced from Raretto lab sheet
export const NUTRITION = {
  hazelnut:     { energy: 541.2, protein: 12.38, satFat: 21.91, unsatFat: 9.40, sugar: 37.10, carbs: 52.48, sodium: 81.1 },
  paan:         { energy: 528.4, protein: 10.80, satFat: 22.70, unsatFat: 7.55, sugar: 35.50, carbs: 53.44, sodium: 102.7 },
  cookies:      { energy: 547.8, protein: 9.65,  satFat: 24.94, unsatFat: 8.72, sugar: 41.67, carbs: 51.58, sodium: 193.0 },
  biscoff:      { energy: 550.4, protein: 9.12,  satFat: 23.77, unsatFat: 10.12, sugar: 36.52, carbs: 52.22, sodium: 127.2 },
  darkfantasy:  { energy: 512.0, protein: 7.81,  satFat: 19.21, unsatFat: 7.52, sugar: 30.34, carbs: 60.06, sodium: 107.6 },
  coconut:      { energy: 559.0, protein: 9.15,  satFat: 28.53, unsatFat: 7.16, sugar: 35.35, carbs: 50.31, sodium: 90.6 },
  coffee:       { energy: 539.7, protein: 11.82, satFat: 20.40, unsatFat: 11.30, sugar: 38.93, carbs: 51.78, sodium: 78.4 },
  nutella:      { energy: 520.4, protein: 11.94, satFat: 17.50, unsatFat: 9.84, sugar: 27.04, carbs: 56.65, sodium: 33.1 },
  caramel:      { energy: 544.7, protein: 9.31,  satFat: 21.45, unsatFat: 11.58, sugar: 38.23, carbs: 52.56, sodium: 258.5 },
  orange:       { energy: 496.0, protein: 7.61,  satFat: 16.61, unsatFat: 9.24, sugar: 41.90, carbs: 58.22, sodium: 84.1 },
  mangoes:      { energy: 518.8, protein: 7.79,  satFat: 21.50, unsatFat: 6.51, sugar: 42.34, carbs: 58.89, sodium: 102.4 },
  gulkand:      { energy: 533.7, protein: 9.28,  satFat: 23.62, unsatFat: 8.93, sugar: 31.98, carbs: 50.91, sodium: 92.6 },
  blackcurrant: { energy: 520.8, protein: 9.05,  satFat: 24.15, unsatFat: 6.47, sugar: 28.67, carbs: 52.26, sodium: 103.5 },
};

// The Founder — Shlok Rathi
export const FOUNDER = {
  name: 'Shlok Rathi',
  title: 'Founder, Raretto',
  city: 'Mumbai',
  // Portrait served from /public; CRA exposes it at /founder.png
  image: '/founder.png',
  quote: 'India has always understood flavour. What it lacked was a chocolate house to speak that language fluently.',
};

// Barks — next chapter
export const BARK_FLAVORS = [
  { id: 'mango-chill', name: 'Mango Chill', notes: 'Alphonso mango, cooling mint, dark chocolate', color: '#e59a2b', badge: 'The Signature' },
  { id: 'rose-pistachio', name: 'Rose Pistachio', notes: 'Persian rose petals, slivered pistachio', color: '#c96b8a', badge: 'Monsoon 2026' },
  { id: 'salted-caramel', name: 'Sea Salt Caramel', notes: 'Slow-cooked caramel, flake salt', color: '#b07a3a', badge: 'Monsoon 2026' },
  { id: 'espresso-hazel', name: 'Espresso Hazel', notes: 'Cold-brew espresso, toasted hazelnut', color: '#4a2b1a', badge: 'Monsoon 2026' },
  { id: 'coconut-lime', name: 'Coconut & Kaffir Lime', notes: 'Toasted coconut, kaffir lime zest', color: '#8ea86a', badge: 'Monsoon 2026' },
  { id: 'dark-orange', name: 'Dark Orange Peel', notes: '72% dark chocolate, candied orange peel', color: '#c85a1a', badge: 'Monsoon 2026' },
];

// Home — brand pillars
export const PILLARS = [
  { title: 'A different question', text: 'Many generations understood ingredients. This one asked what would happen if India spoke its heritage through chocolate.' },
  { title: 'Composed, not manufactured', text: 'Small batches. Slow tempering. Every piece finished by hand .' },
  { title: 'Ingredients, first', text: 'Belgian couverture. Piedmont hazelnut. Alphonso from Ratnagiri. Rose gulkand cured in the sun. Nothing borrowed. Nothing inferior.' },
  { title: 'Proudly Indian, quietly global', text: 'Paan, gulkand, coffee from Chikmagalur, crafted to the standard of the world’s finest chocolate houses.' },
];

// Testimonials — restrained voices
export const TESTIMONIALS = [
  { name: 'Hetvi Patel', image: 'https://raretto.com/wp-content/uploads/2025/09/Hetvi-Patel-e1753103993348.jpg', text: 'The first Indian chocolate I have opened slowly. Every flavour holds a memory, but nothing feels borrowed. It is entirely its own.' },
  { name: 'Prachi Wagh',  image: 'https://raretto.com/wp-content/uploads/2025/09/prachi-wagh.webp', text: 'I no longer gift European chocolate. Raretto is what I send to family in Bombay, to clients in London. It travels beautifully in both directions.' },
  { name: 'Charu Pawar',  image: 'https://raretto.com/wp-content/uploads/2025/09/charu-pawar.webp', text: 'Considered. That is the word. Every detail from the temper to the packaging has been thought through.' },
  { name: 'Eshan Rai',    image: 'https://raretto.com/wp-content/uploads/2025/09/eshan-rai.webp', text: 'Paan in chocolate should not work. Here, it does. It is the most fluent expression of India I have tasted in a long time.' },
  { name: 'Akanksha Pandey', image: 'https://raretto.com/wp-content/uploads/2025/09/akanksha-pandey.webp', text: 'The gulkand is exceptional. I have started ending dinner with a single piece the way one closes a meal in a good restaurant.' },
];

// Box builder
export const BOX_SIZES = [
  { size: 8,  label: 'Share',    tagline: 'Gift-considered' },
  { size: 12, label: 'Grand',    tagline: 'The full house' },
  { size: 24, label: 'Estate',   tagline: 'For the whole gathering' },
];

export const FREE_SHIPPING_THRESHOLD = 400;
export const STANDARD_SHIPPING = 100;

export const ANNOUNCEMENTS = [
  'Free shipping on orders above ₹400',
  'Composed, tempered and hand-finished in Mumbai',
  'Build a private box, curated to the piece',
  'Raretto Barks arrives Monsoon 2026',
];
